module.exports = __webpack_public_path__ + "static/media/icon-drip.ce09ca82.svg";